import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NgxCarouselModule } from 'ngx-carousel';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../../core/components/widget/widget.module';

import { CourseYearService } from '../../../../../services/cour-years/course-year.service';
import { SchoolScheduleSchoolYearComponent } from './school-schedule-school-year.component';

const routes = [
    {
        path: 'pages/management/schoolschedulebyyear',
        component: SchoolScheduleSchoolYearComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_DIVISIONS',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    }
];

@NgModule({
    declarations: [
        SchoolScheduleSchoolYearComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule
    ],
    exports: [
    ],
    providers: [
        CourseYearService
    ],
    entryComponents: [
    ]
})

export class SchoolScheduleSchoolYearModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/schoolyear/school-schedule-school-year/school-schedule-school-year.module.ts